// extracted by mini-css-extract-plugin
export default {"ActionPage":"ActionPage_ActionPage__r-2JJ","instructionContent":"ActionPage_instructionContent__158aE"};